const Logo = ({ className, svg }) => {

    return (
        <div className={`${className}__wrap-logo`}>
            <img src={svg} className={`${className}__logo`} alt="logo" />
        </div>
    );
}

export default Logo;